export default __webpack_public_path__ + "static/media/message-sms-active-icon.bfaf4b7a.svg";